import { lightTheme } from "@/customTheme"

const SvgComponent = ({ size, disabled }: { size: number, disabled?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size} height={size}
    fill="none"
  >
    <path
      fill={disabled ? lightTheme.colors.icon.disable : lightTheme.colors.blackGray}
      d="m14.021 5.255 2.921 2.918h-2.55V8.17H9.325a5.324 5.324 0 0 0-5.324 5.323v.888a5.325 5.325 0 0 0 5.324 5.324h5.068v-1.775H9.325a3.55 3.55 0 0 1-3.55-3.55v-.887a3.55 3.55 0 0 1 3.55-3.549H11.1v.002h5.843l-2.922 2.922 1.255 1.255 4.437-4.437a.887.887 0 0 0 0-1.254L15.276 4l-1.255 1.255Z"
    />
  </svg>
)
export default SvgComponent
